var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
export function getIssuesCaughtVsResolved(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/issues_caught_vs_resolved', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate
            }
        });
        return response.data;
    });
}
export function getAvgProcessingTime(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/avg_processing_time', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate
            }
        });
        return response.data;
    });
}
export function getAvgResubmissions(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/avg_resubmissions', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate
            }
        });
        return response.data;
    });
}
export function getEscapedIssues(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/escaped_issues', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate
            }
        });
        return response.data;
    });
}
export function getEscapedIssuesDetail(filters_1, issueType_1) {
    return __awaiter(this, arguments, void 0, function* (filters, issueType, page = 1, perPage = 10, technicianIds = [], buildingIds = [], sortBy, sortDirection) {
        const response = yield api.get('/api/internal/ia_insights/escaped_issues_detail', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate,
                issue_type: issueType,
                page,
                per_page: perPage,
                technician_ids: technicianIds.length > 0 ? technicianIds : undefined,
                building_ids: buildingIds.length > 0 ? buildingIds : undefined,
                sort_by: sortBy || undefined,
                sort_direction: sortDirection || undefined
            },
        });
        return response.data;
    });
}
export function getTopIssueCategories(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/top_issue_categories', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate
            }
        });
        return response.data;
    });
}
export function getDismissedVsResolved(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/dismissed_vs_resolved', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate
            }
        });
        return response.data;
    });
}
export function getTechsNeedingCoaching(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/techs_needing_coaching', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate
            }
        });
        return response.data;
    });
}
export function getTotalOpenIssues(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/total_open_issues', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate
            }
        });
        return response.data;
    });
}
export function getProcessingRuns(filters_1) {
    return __awaiter(this, arguments, void 0, function* (filters, page = 1, perPage = 10, technicianIds = [], buildingIds = [], sortBy, sortDirection) {
        const response = yield api.get('/api/internal/ia_insights/processing_runs', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate,
                page,
                per_page: perPage,
                technician_ids: technicianIds.length > 0 ? technicianIds : undefined,
                building_ids: buildingIds.length > 0 ? buildingIds : undefined,
                sort_by: sortBy || undefined,
                sort_direction: sortDirection || undefined
            }
        });
        return response.data;
    });
}
export function getInspectionResubmissions(filters_1) {
    return __awaiter(this, arguments, void 0, function* (filters, page = 1, perPage = 10, technicianIds = [], buildingIds = [], sortBy, sortDirection) {
        const response = yield api.get('/api/internal/ia_insights/inspection_resubmissions', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate,
                page,
                per_page: perPage,
                technician_ids: technicianIds.length > 0 ? technicianIds : undefined,
                building_ids: buildingIds.length > 0 ? buildingIds : undefined,
                sort_by: sortBy || undefined,
                sort_direction: sortDirection || undefined
            }
        });
        return response.data;
    });
}
export function getTechDetail(filters, technicianId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/tech_detail', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate,
                technician_id: technicianId
            }
        });
        return response.data;
    });
}
function initialsForName(name) {
    const initials = name
        .split(/\s+/)
        .filter(Boolean)
        .map((part) => part[0])
        .join('')
        .toUpperCase();
    return initials || '?';
}
function mapScoreTrend(trend) {
    switch (trend) {
        case 'improving': return 'up';
        case 'declining': return 'down';
        case 'stable': return 'stable';
        case 'neutral': return 'neutral';
        case 'up': return 'up';
        case 'down': return 'down';
        default: return null;
    }
}
export function mapTechPerformanceRow(row) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
    const name = (_c = (_b = (_a = row.name) !== null && _a !== void 0 ? _a : row.technicianName) !== null && _b !== void 0 ? _b : row.technician_name) !== null && _c !== void 0 ? _c : 'Unknown technician';
    const stableId = (_e = (_d = row.id) !== null && _d !== void 0 ? _d : row.technicianId) !== null && _e !== void 0 ? _e : row.technician_id;
    const technicianId = (_h = (_g = (_f = row.technicianId) !== null && _f !== void 0 ? _f : row.technician_id) !== null && _g !== void 0 ? _g : stableId) !== null && _h !== void 0 ? _h : 0;
    if (stableId == null) {
        // eslint-disable-next-line no-console
        console.warn('[mapTechPerformanceRow] Row missing both id and technician_id', row);
    }
    return {
        id: stableId !== null && stableId !== void 0 ? stableId : technicianId,
        technicianId,
        name,
        avatarInitials: (_k = (_j = row.avatarInitials) !== null && _j !== void 0 ? _j : row.avatar_initials) !== null && _k !== void 0 ? _k : initialsForName(name),
        avatarColor: (_m = (_l = row.avatarColor) !== null && _l !== void 0 ? _l : row.avatar_color) !== null && _m !== void 0 ? _m : '#763584',
        currentRating: (_p = (_o = row.currentRating) !== null && _o !== void 0 ? _o : row.current_rating) !== null && _p !== void 0 ? _p : null,
        currentScore: (_r = (_q = row.currentScore) !== null && _q !== void 0 ? _q : row.current_score) !== null && _r !== void 0 ? _r : null,
        scoreTrend: mapScoreTrend((_s = row.scoreTrend) !== null && _s !== void 0 ? _s : row.score_trend),
        summary: (_t = row.summary) !== null && _t !== void 0 ? _t : null,
        coachingRecommendationMd: (_v = (_u = row.coachingRecommendationMd) !== null && _u !== void 0 ? _u : row.coaching_recommendation_md) !== null && _v !== void 0 ? _v : null,
        generatedAt: (_x = (_w = row.generatedAt) !== null && _w !== void 0 ? _w : row.generated_at) !== null && _x !== void 0 ? _x : null,
        status: (_y = row.status) !== null && _y !== void 0 ? _y : null,
        topIssue: (_0 = (_z = row.topIssue) !== null && _z !== void 0 ? _z : row.top_issue) !== null && _0 !== void 0 ? _0 : null,
        issuesFlagged: (_1 = row.issuesFlagged) !== null && _1 !== void 0 ? _1 : row.issues_flagged,
        resolutionRate: (_2 = row.resolutionRate) !== null && _2 !== void 0 ? _2 : row.resolution_rate,
        avgResubmissions: (_3 = row.avgResubmissions) !== null && _3 !== void 0 ? _3 : row.avg_resubmissions,
        coachingPriority: (_4 = row.coachingPriority) !== null && _4 !== void 0 ? _4 : row.coaching_priority
    };
}
export function getTechPerformance(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get('/api/internal/ia_insights/tech_performance', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate
            }
        });
        return { data: response.data.data.map(mapTechPerformanceRow) };
    });
}
export function exportOpenIssues(filters_1, issueType_1) {
    return __awaiter(this, arguments, void 0, function* (filters, issueType, technicianIds = [], buildingIds = []) {
        const response = yield api.post('/api/internal/ia_insights/export_open_issues', {
            start_date: filters.values.dateRange.startDate,
            end_date: filters.values.dateRange.endDate,
            issue_type: issueType,
            technician_ids: technicianIds.length > 0 ? technicianIds : undefined,
            building_ids: buildingIds.length > 0 ? buildingIds : undefined
        });
        return response.data;
    });
}
export function exportProcessingRuns(filters_1) {
    return __awaiter(this, arguments, void 0, function* (filters, technicianIds = [], buildingIds = []) {
        const response = yield api.post('/api/internal/ia_insights/export_processing_runs', {
            start_date: filters.values.dateRange.startDate,
            end_date: filters.values.dateRange.endDate,
            technician_ids: technicianIds.length > 0 ? technicianIds : undefined,
            building_ids: buildingIds.length > 0 ? buildingIds : undefined
        });
        return response.data;
    });
}
export function exportResubmissions(filters_1) {
    return __awaiter(this, arguments, void 0, function* (filters, technicianIds = [], buildingIds = []) {
        const response = yield api.post('/api/internal/ia_insights/export_resubmissions', {
            start_date: filters.values.dateRange.startDate,
            end_date: filters.values.dateRange.endDate,
            technician_ids: technicianIds.length > 0 ? technicianIds : undefined,
            building_ids: buildingIds.length > 0 ? buildingIds : undefined
        });
        return response.data;
    });
}
export function exportEscapedIssues(filters_1, issueType_1) {
    return __awaiter(this, arguments, void 0, function* (filters, issueType, technicianIds = [], buildingIds = []) {
        var _a;
        const response = yield api.post('/api/internal/ia_insights/export_escaped_issues', {
            start_date: filters.values.dateRange.startDate,
            end_date: filters.values.dateRange.endDate,
            issue_type: issueType,
            technician_ids: technicianIds.length > 0 ? technicianIds : undefined,
            building_ids: buildingIds.length > 0 ? buildingIds : undefined
        }, { responseType: 'blob' });
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const disposition = response.headers['content-disposition'];
        const filename = ((_a = disposition === null || disposition === void 0 ? void 0 : disposition.match(/filename="?(.+?)"?$/)) === null || _a === void 0 ? void 0 : _a[1]) || 'escaped-issues.csv';
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    });
}
export function getOpenIssues(filters_1, issueType_1) {
    return __awaiter(this, arguments, void 0, function* (filters, issueType, page = 1, perPage = 10, technicianIds = [], buildingIds = [], sortBy, sortDirection) {
        const response = yield api.get('/api/internal/ia_insights/open_issues', {
            params: {
                start_date: filters.values.dateRange.startDate,
                end_date: filters.values.dateRange.endDate,
                issue_type: issueType,
                page,
                per_page: perPage,
                technician_ids: technicianIds.length > 0 ? technicianIds : undefined,
                building_ids: buildingIds.length > 0 ? buildingIds : undefined,
                sort_by: sortBy || undefined,
                sort_direction: sortDirection || undefined
            }
        });
        return response.data;
    });
}
